import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbService } from '../../services/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './breadcrumb.component.css',
})
export class BreadcrumbComponent {
  private readonly breadcrumbService = inject(BreadcrumbService);

  get breadcrumbs() {
    return this.breadcrumbService.breadcrumbs();
  }

  /** The breadcrumb trail with the ☰ root and standalone Home items stripped
   * (the toolbar hamburger and logo already serve those roles). */
  get visibleBreadcrumbs() {
    return this.breadcrumbs.filter((item) => !item.isMenuRoot && item.url !== '/');
  }

  /** Last 2 breadcrumb items shown on mobile: parent link + current title. */
  get mobileBreadcrumbs() {
    const visible = this.visibleBreadcrumbs;
    if (visible.length < 2) return visible;
    return visible.slice(-2);
  }
}
